export default "__VITE_ASSET__BPr21HNR__"